import { Component, inject, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<router-outlet/>',
  standalone: false,
})
export class AppRouterComponent {

  // Note this is needed for color pickers in editors (HTML builder, Template editor)
  public readonly vcRef = inject(ViewContainerRef);

}
